import { Application } from "@hotwired/stimulus"
import DropdownController from "./dropdown_controller"
import BibRulesController from "./bib_rules_controller"
import EntrantSortingController from "./entrant_sorting_controller"
import MaxBibController from "./max_bib_controller"
import TabSwitchController from "./tab_switch_controller"
import UploadFileController from "./upload_file_controller"
import ReactLoadController from "./react_load_controller"
import StillRacingController from "./still_racing_controller"
import PrizeGroupsController from "./prize_group_controller"
import PrintLabelsController from "./print_labels_controller"
import EventControlsController from "./event_controls"
import MapController from "./map_controller"
import DatatablesController from "./datatables_controller";
import ResultsController from "./results_controller"
import TrackingController from "./tracking_controller"
import StartNowController from "./start_now_controller"
import TimeController from "./time_controller"
import MapLocationsController from "./map_locations_controller"
import BeaconLookupController from "./beacon_lookup_controller"

const application = Application.start()
application.register("dropdown", DropdownController)
application.register("bib_rule", BibRulesController)
application.register("entrant-sorting", EntrantSortingController)
application.register("max-bib", MaxBibController)
application.register("tab_switch", TabSwitchController)
application.register("upload_file", UploadFileController)
application.register("react-load", ReactLoadController)
application.register("still-racing-load", StillRacingController)
application.register("prize-groups", PrizeGroupsController)
application.register("print-labels", PrintLabelsController)
application.register("event-controls", EventControlsController)
application.register("map", MapController)
application.register("datatables", DatatablesController)
application.register("results", ResultsController)
application.register("tracking-load", TrackingController)
application.register("start-now", StartNowController)
application.register("time", TimeController)
application.register("map-locations", MapLocationsController)
application.register("beacon-lookup", BeaconLookupController)

application.debug = false
window.Stimulus = application